/**
 * Configuration constants for test case generation
 */
export const TEST_CASE_GENERATION_CONFIG = {
  // Default generation parameters
  DEFAULT_COUNT: 10,
  DEFAULT_INCLUDE_NEGATIVE: true,
  DEFAULT_INCLUDE_INTEGRATION: true,
  DEFAULT_FOCUS_IMPACTED_STORIES: true,
  
  // UI timing constants
  MESSAGE_ROTATION_INTERVAL_MS: 3500, // Increased interval for better readability
  MODAL_CLOSE_DELAY_MS: 1000,
  
  // UI constants
  MODAL_MIN_HEIGHT: '500px',
  
  // Progress messages
  PROGRESS_MESSAGES: [
    "Reading your PRD like a paranoid QA lead…",
    "Arguing with the AI about edge cases…",
    "Mapping acceptance criteria to real test scenarios…",
    "Checking which stories will cry if this change goes live…",
    "Picking on your FX rates the way auditors do…",
    "Writing tests your devs will definitely complain about…",
    "Prioritizing tests so you know what breaks first…",
    "Finding all the ways this could go wrong…",
    "Cross-referencing with impacted stories…",
    "Making sure we test the happy path AND the sad path…"
  ]
};

